import React from 'react';
import PropTypes from 'prop-types';
import { LiveFeedPlaysWrapper } from './LiveFeedPlays.style';
import { LiveFeedPlayDataContainer } from '../../Play';

const LiveFeedPlays = ({
    playArr = [],
    teams,
    offset,
    reverseChron = false,
    showAllPitches = false,
    showAnimations,
    openAtBatOverlay,
    showPitchesOnly,
    showBasesText
}) => {
    const orderedPlayArr = reverseChron ? [...playArr].reverse() : playArr;

    return (
        <LiveFeedPlaysWrapper>
            {
                orderedPlayArr.map((index) => {
                    return (

                        <LiveFeedPlayDataContainer
                            showAllPitches={ showAllPitches }
                            key={ `live-feed-play-${index}` }
                            dataIndex={ index }
                            teams={ teams }
                            offset={ offset }
                            reverseChron={ reverseChron }
                            showAnimations={ showAnimations }
                            openAtBatOverlay={ openAtBatOverlay }
                            showPitchesOnly={ showPitchesOnly }
                            showBasesText= { showBasesText }
                        />

                    );
                })
            }
        </LiveFeedPlaysWrapper>
    );
};

LiveFeedPlays.propTypes = {
    playArr: PropTypes.arrayOf(PropTypes.number),
    teams: PropTypes.object,
    offset: PropTypes.bool,
    reverseChron: PropTypes.bool,
    showAllPitches: PropTypes.bool,
    showAnimations: PropTypes.bool,
    showPitchesOnly: PropTypes.bool,
    showBasesText: PropTypes.bool,
    openAtBatOverlay: PropTypes.func
};

export default LiveFeedPlays;
